exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pagination-stat[data-v-4d1a7c72]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.pagination-stat .stat[data-v-4d1a7c72]{font-size:16px}.redirect-dialog[data-v-4d1a7c72] .el-dialog__body{padding:15px 25px 0px}\n", ""]);

// exports
